import styled from "styled-components";

export const GenericErrorWrapper= styled.div `
    width: 100%;
    height: 100dvh;
    display: flex;
    justify-content: center;
    align-items: center;
`;